var React = require('react');

function ArrowdownInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1 1L6 6L11 1","stroke":"url(#paint9901_linear)","strokeWidth":"2","key":0}),React.createElement("defs",{"key":1},React.createElement("linearGradient",{"id":"paint9901_linear","x1":"6","y1":"1","x2":"6","y2":"6","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"stopColor":"#E9C080","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#AA7C3E","key":1})]))]);
}

ArrowdownInline.defaultProps = {"width":"12","height":"8","viewBox":"0 0 12 8","fill":"none"};

module.exports = ArrowdownInline;

ArrowdownInline.default = ArrowdownInline;
